import { ref } from 'vue';

const screenshotMode = ref(false);

export function useScreenshotMode() {
  return { screenshotMode };
}
